import { render, staticRenderFns } from "./UpgradeDisplay.vue?vue&type=template&id=54406344&scoped=true"
import script from "./UpgradeDisplay.vue?vue&type=script&lang=js"
export * from "./UpgradeDisplay.vue?vue&type=script&lang=js"
import style0 from "./UpgradeDisplay.vue?vue&type=style&index=0&id=54406344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54406344",
  null
  
)

export default component.exports